<template>
  <div ref="productTag" class="tag" :class="'bubble-'+bubbleLocation" :style="{ left: `${coordinates.x * 100}%`, top: `${coordinates.y * 100}%` }">
    <transition name="scale">
      <div v-if="isTagVisible">
        <a class="tag-body" :class="arrowDirection" :href="productUrl">
          <ResponsiveImage
            v-if="showImage"
            :url="product.imageUrl"
            :widths="[80]"
            :breakpoints="[80]"
            :skeleton="true"
          ></ResponsiveImage>
          <div class="productDetail">
            <p>{{ product.title }}</p>
            <span class="originalPrice" v-if="product.onSale || product.onClearance"> {{ product.originalPrice }} </span>
            <span class="newPrice"> {{ product.price }} </span>
          </div>

          <i class="af af-chevron-right" />
        </a>
      </div>
    </transition>

    <transition name="scale">
      <div v-if="isAnchorVisible" class="tag-anchor" :class="bubbleLocation" />
    </transition>
  </div>
</template>

<script>
import { toRefs, ref, computed } from 'vue';
import {useRouter} from 'vue-router';
import ResponsiveImage from '@/components/commons/ResponsiveImage.vue';

export default {
  name: 'ImageProductTag',
  components: {
    ResponsiveImage,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    coordinates: {
      type: Object,
      required: true,
    },
    bubbleLocation: {
      type: String,
      default: 'right',
    },
    isTagVisible: {
      type: Boolean,
      default: false,
    },
    isAnchorVisible:{
      type: Boolean,
      default: false,
    },
    showImage:{
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const { product, coordinates, bubbleLocation, isTagVisible, isAnchorVisible , showImage} = toRefs(props);

    const arrowDirection = computed(()=>{
      switch(bubbleLocation.value){
        case "top":
          return "bottom";
        case "bottom":
          return "top";
        case "left":
          return "right";
        case "right":
          return "left";
        default:
          return "";
      }
    })
            
    const router = useRouter();


    const productUrl = computed(()=>{
      return router.resolve({
        name: 'product',
        params: {
          id: product.value.hashKey,
          slug: product.value.slug,
        },
      }).href;
    })

    return {
      product,
      coordinates,
      bubbleLocation,
      arrowDirection,
      isAnchorVisible,
      isTagVisible,
      productUrl,
      showImage
    };
  },
};
</script>

<style lang="postcss" scoped>
@import '@/pixel/style/variables';
@import '@/pixel/style/productTags';
.tag {
  position: absolute;
  z-index: 1;
  .tag-body {
    display: flex;
    justify-content: space-between;

    &:active{
      background-color: var(--grey-ultra-light);
    }

    .image{
      width: 80px;
      margin-right: 10px;
      height: auto;
      ::v-deep(img) {
        object-fit: contain;
      }
    }
    .productDetail{
      min-width: calc(100% - 80px);
    }
    .originalPrice {
      font-size: 0.8em;
      text-decoration: line-through;
      color: var(--grey-medium);
      margin-right: 0.5em;
    }
    .af-chevron-right {
      align-self: center;
    }
  }
  .tag-anchor{
    margin-left: -7px;
    margin-top: -7px;
    transform-origin: center;
  }

  &.bubble-top{
    .tag-body{
      transform: translate(-50%,calc(-100% - 20px));
      &:after{
        transform: translateX(50%);
      }
    }
  }
  &.bubble-bottom{
    .tag-body{
      transform: translate(-50%,20px);
      &:after{
        transform: translateX(50%);
      }
    }
  }
  &.bubble-left{
    .tag-body{
      transform: translate(calc(-100% - 20px),-50%);
    }
  }
  &.bubble-right{
    .tag-body{
      transform: translate(20px,-50%);
    }
  }
}
</style>
